import { createSelector } from '@reduxjs/toolkit';

import { selectExternalTourBannerImageUrl } from './selectExternalTourBannerImageUrl';
import { selectNewbuildingTourBannerImageUrl } from './selectNewbuildingTourBannerImageUrl';
import { isNewbuildingSelector } from '../offer';

export const selectTourBannerImageUrl = createSelector(
  selectNewbuildingTourBannerImageUrl,
  selectExternalTourBannerImageUrl,
  isNewbuildingSelector,
  (newbuildingTourBannerImageUrl, externalTourBannerImageUrl, isNewbuilding) =>
    isNewbuilding ? newbuildingTourBannerImageUrl : externalTourBannerImageUrl,
);
